import * as React from "react";

function Report(props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.82 2.775L1.605 3.66L3.3225 6C3.77811 5.76067 4.26187 5.57926 4.7625 5.46L2.82 2.775ZM8.25 6.75V8.25H13.5V8.4675L9.75 9.5325V11.625C9.75 12.2925 9.55206 12.945 9.18121 13.5C8.81036 14.0551 8.28326 14.4876 7.66656 14.7431C7.04986 14.9985 6.37126 15.0654 5.71657 14.9351C5.06189 14.8049 4.46052 14.4835 3.98852 14.0115C3.51651 13.5395 3.19508 12.9381 3.06485 12.2834C2.93463 11.6287 3.00146 10.9501 3.25691 10.3334C3.51235 9.71674 3.94494 9.18964 4.49995 8.81879C5.05497 8.44794 5.70749 8.25 6.375 8.25H6.75V6.75H6.375C5.41082 6.75 4.46829 7.03591 3.6666 7.57159C2.86491 8.10726 2.24007 8.86863 1.87109 9.75942C1.50211 10.6502 1.40557 11.6304 1.59367 12.5761C1.78178 13.5217 2.24608 14.3904 2.92786 15.0721C3.60964 15.7539 4.47828 16.2182 5.42394 16.4063C6.36959 16.5944 7.34979 16.4979 8.24058 16.1289C9.13137 15.7599 9.89274 15.1351 10.4284 14.3334C10.9641 13.5317 11.25 12.5892 11.25 11.625V10.4325L16.5 9V6.75H8.25ZM12.18 2.775L10.3875 5.25H12.24L13.395 3.66L12.18 2.775ZM6.75 1.5V5.25H8.25V1.5H6.75Z"
        fill="white"
      />
    </svg>
  );
}

export default Report;
